import type { AnalyticsEvent } from "../types/analyticsEvent.types";
import { consoleLogPackagesAnalytics } from "./consoleLogPackagesAnalytics";

type TrackCrossPlatformProps = {
  event: AnalyticsEvent;
};

export const trackCrossPlatform = ({ event }: TrackCrossPlatformProps) => {
  if (typeof window !== "undefined") {
    if ("webkit" in window)
      window.webkit.messageHandlers?.["track"].postMessage(event);
    if ("Android" in window) window.Android?.["track"]?.(JSON.stringify(event));
    /** For Web Development */
    if (!("Android" in window) && !("webkit" in window))
      consoleLogPackagesAnalytics({
        heading: "trackCrossPlatform",
        message: `${event.event}: ${JSON.stringify(event.properties)}`,
      });
  }
};
